/* eslint-disable regexp/no-unused-capturing-group */
const strippedString = (str: string) => str.replace(/(<([^>]+)>)/g, '')

export default strippedString
